
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { SaleService } from '../../../services/sale.service';
import { ReportsService } from '../../reports/reports.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { PaginatorModule } from 'primeng/paginator';
import { Sale } from '../../../models/sale.model';


@Component({
  selector: 'app-list-sail',
  imports: [
    CommonModule,
    FormsModule,
    ConfirmDialogModule,
    ToastModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    DatePickerModule,
    PaginatorModule
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-sail.component.html'
})
export class ListSailComponent {

  status = [
    { label: 'Todos', value: null},
    { label: 'Canceladas', value: true },
    { label: 'Quitadas', value: false }
  ];

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  searchTerm: string = '';
  initialDate: Date = new Date();
  finalDate: Date = new Date();
  selectedStatus = this.status[0].value;
  sales: Sale[] = [];
  loading: boolean = false;
  totalRecords: number = 0;

  first: number = 0;
  rows: number = 5;
  currentPage: number = 1;
  
  constructor(
    private saleService: SaleService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    // Inicializar datas com início e fim do dia
    const today = new Date();
    this.initialDate = this.getStartOfDay(today);
    this.finalDate = this.getEndOfDay(today);
    
    this.searchSubscription = this.searchSubject.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(term => {
          this.searchTerm = term;
          this.getData();
        });
  }

  private getStartOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  private getEndOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.saleService.getAll(this.searchTerm, this.initialDate, this.finalDate, this.selectedStatus, this.currentPage).subscribe({
        next: (data) => {
          this.sales = data.data,
          this.totalRecords = data.pagination?.totalRecords
        },
        error: (error) => {

        }
      })
  }


  onSearchChange() 
  {
    this.searchSubject.next(this.searchTerm);
  }

  onStatusChange(){
    // Garantir que as datas tenham hora zerada/início e fim do dia
    this.initialDate = this.getStartOfDay(this.initialDate);
    this.finalDate = this.getEndOfDay(this.finalDate);
    this.getData();
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  openPdv(){
     const width = window.screen.width;
     const height = window.screen.height;
     window.open('/pdv', 'PDV', `width=${width},height=${height},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no`);
    // this.router.navigate(['/app/pdv']);
  }

  view(sale: Sale){
      this.router.navigate(['/app/sales/view', sale.id]);
  }

  cancel(sale: Sale){
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar este item?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.saleService.cancel(sale.id).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Sucesso!', detail: 'Venda cancelada com sucesso!', life: 3000 });
            this.getData();
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'Erro!', detail: 'Não foi possível cancelar a venda!', life: 3000 });
          }
        });
      },
      reject: () => {
        console.log('Exclusão cancelada');
      }
    });
  }

  exportGet(sale: Sale){
      this.saleService.exportGet(sale.id).subscribe(
      {
        next: (response) => {
          const url = window.URL.createObjectURL(response);
          window.open(url, '_blank');
        },
        error: (error) => {
          console.log(error);
        }
      }
    );;
  }

  export(){
    this.saleService.export(this.searchTerm, this.initialDate, this.finalDate, this.selectedStatus,).subscribe({
      next: (file) => {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
